export default __webpack_public_path__ + "static/media/411.1546ab98.jpg";